export const Icons = () => {
  return (
    <section className="section" id="icon">
      <h1 className="title">Icons</h1>
      <hr />
      <span className="icon">
        {" "}
        <i className="fas fa-home"> </i>{" "}
      </span>
      <span className="icon is-medium">
        {" "}
        <i className="fas fa-lg fa-home"> </i>{" "}
      </span>
      <span className="icon is-large">
        {" "}
        <i className="fas fa-2x fa-home"> </i>{" "}
      </span>
    </section>
  );
};
